import React from 'react';
import { Link } from 'react-router-dom';
export const Banner = () => {
  return <div className="w-full bg-gradient-to-r from-slate-800 to-slate-900 text-white" data-id="element-28">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between" data-id="element-29">
        <Link to="/" className="flex items-center" data-id="element-30">
          <div className="bg-white p-1 rounded-md mr-3" data-id="element-31">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/frRxPrnaSucxDRNSDipJQS/Bolide_Logo.png" alt="Bolide" className="h-8" data-id="element-32" />
          </div>
          <span className="font-bold text-lg hidden sm:block" data-id="element-33">
            Solar Management
          </span>
        </Link>
        <div className="text-sm" data-id="element-34">
          <span className="hidden md:inline-block mr-3" data-id="element-35">
            Powering the future with clean energy
          </span>
          <span className="bg-pink-600 px-3 py-1 rounded-full text-xs font-medium" data-id="element-36">
            Dashboard
          </span>
        </div>
      </div>
    </div>;
};